import { ContractConceptRelationshipState } from '../../states/ContractConceptRelationship.State';
import ContractConceptRelationshipGetAllReducer from './ContractConceptRelationship.GetAll.Reducer';
import ContractConceptRelationshipCreateReducer from './ContractConceptRelationship.Create.Reducer';
import ContractConceptRelationshipUpdateReducer from './ContractConceptRelationship.Update.Reducer';
import ContractConceptRelationshipDeleteReducer from './ContractConceptRelationship.Delete.Reducer';
import * as CommonFunctions from '../Common/Functions';

export const CombinedContractConceptRelationshipReducer = CommonFunctions.reduceReducers<ContractConceptRelationshipState>(
  ContractConceptRelationshipGetAllReducer,
  ContractConceptRelationshipCreateReducer,
  ContractConceptRelationshipUpdateReducer,
  ContractConceptRelationshipDeleteReducer
);
